export default "__VITE_ASSET__CvbZH7qW__"